import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ModalComponent from '@components/interface/ModalComponent';
import Loading from '@components/LoadingProcess';
import { useDetailedOrders, useGetOrdersWithStatus } from '@pages/Orders/hooks/orders';
import { isActiveKanbanOrder } from '@utils/hooks/reconcileActiveOrders';
import { OrderDetail } from '@interfaces/OrderTypes';
import toast from 'react-hot-toast';
import { SelfServiceOrdersModal } from './components/SelfServiceOrdersModal';
import useModules from '@utils/hooks/useModules';
import { ModuleName } from '@utils/constants';

export const SelfServiceOrders = () => {
  const { tableID, tableNumber } = useParams();
  const { orders } = useGetOrdersWithStatus();
  const { getOrder } = useDetailedOrders();
  const [isFetching, setIsFetching] = useState(true);
  const [orderList, setOrderList] = useState<OrderDetail[]>([]);
  const { modulePermissions } = useModules();
  const permissions = modulePermissions(ModuleName.HISTORIAL);

  useEffect(() => {
    const filterOrders = async () => {
      if (!tableID || orders.length === 0) return;

      try {
        setIsFetching(true);

        // Un pedido de mesa pertenece a la cuenta abierta en CUALQUIER estado activo (mismo predicado
        // que el Kanban y la card de mesa), no solo pending/accepted: si avanzó a on_the_way /
        // preparación, la card lo sigue contabilizando pero este modal lo excluía → "Pedidos de la
        // mesa" salía vacío ($0.00). isActiveKanbanOrder excluye scheduled/delivered/rejected/
        // canceled/pre_checkout, así que la lista aquí == lo que suma la card de la mesa.
        const filteredOrders = orders.filter(
          (order) =>
            order.self_service?.table_uuid === tableID &&
            order.metodo_entrega === 'inRestaurant' &&
            isActiveKanbanOrder(order),
        );
        const data = await Promise.all(
          filteredOrders.map(async (order) => {
            const orderDetails = await getOrder(order.id);
            return orderDetails;
          }),
        );

        setOrderList(data);
      } catch {
        toast.error('Error al obtener los pedidos');
      } finally {
        setIsFetching(false);
      }
    };

    filterOrders();
  }, [tableID, orders]);

  return (
    <ModalComponent title={`Pedidos de la mesa ${tableNumber}`}>
      {isFetching ? (
        <Loading />
      ) : (
        <SelfServiceOrdersModal orders={orderList} isAbleToDelete={permissions.delete || false} />
      )}
    </ModalComponent>
  );
};
